import { createUseStyles } from "react-jss";

export const DownloadDataStyle = createUseStyles((theme: any) => ({
    exportBtn: {
        display: "flex",
        alignItems: "center",
        width: theme.widths.exportBtn.container,
        color: theme.colors.exportBtn.color,
        marginLeft: 12,
        marginRight: 12,
        cursor: "pointer",
    },
}));
